import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react'
import { Navbar, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from 'antd';
import { useAuth } from '../../contexts/auth';
import IconButton from '../common/IconButton';
import Logo from '../common/Logo';
import UserMenu from './UserMenu';

type Props = {
  className?: string;
  showSidebar?: VoidFunction;
}

export default function AppNavbar({ className, showSidebar }: Props) {
  const location = useLocation();
  const { newNotifications } = useAuth();

  const handleSidebarToggle = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    showSidebar?.();
  }

  return (
    <Navbar className={classNames('app-navbar shadow-sm border-bottom', className)} bg="white">

      <IconButton className="me-2" onClick={handleSidebarToggle}>
        <FontAwesomeIcon className="text-secondary" icon={solid('bars')} />
      </IconButton>

      <Link to="/">
        <Navbar.Brand>
          <Logo height={30} className="d-inline-block align-top px-md-3" />
        </Navbar.Brand>
      </Link>

      <Nav className="flex-row align-items-center ms-auto">
        <Nav.Link as={Link} to="/notifications" className={classNames("py-1 me-3", { selected: location.pathname.startsWith("/notifications") })}>
          <Badge count={newNotifications} size="small">
            <FontAwesomeIcon icon={solid('bell')} />
          </Badge>
        </Nav.Link>

        <UserMenu />
      </Nav>
    </Navbar>
  );
}
